var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isContentVisibleToUser())?_c('div',{directives:[{name:"easyadmin",rawName:"v-easyadmin",value:(_vm.easyadminId),expression:"easyadminId"}],class:[_vm.contentType, _vm.spacerClass, _vm.content.hide_mobile ? 'd-none d-lg-block' : ''],style:({'background-color': _vm.content.background_color}),attrs:{"stripe-spacer-component":""}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }